<form #thisForm="ngForm" (ngSubmit)="submit()">
  <style>
    label {
      padding-right: 15px;
    }
  </style>
  <h3>Upload de Arquivo PESC (Boleta de Renda Variável)</h3>
  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados do arquivo de upload</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-12">
          <label>Arquivo</label>
          <input
            type="file"
            name="file"
            data-cy="uploadFile"
            (change)="openFile($event)"
          />
        </div>
      </div>
      <div class="actions">
        <input
          type="button"
          value="Upload"
          data-cy="submit"
          class="btn btn-primary mt-3"
          appDebounceClick
          (debounceClick)="submit()"
          [debounceTime]="200"
        />
      </div>
    </div>
  </div>
</form>
